import { Injectable, Injector } from '@angular/core';
import { DataFieldGroupModel } from './data-field-group-model';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Injectable()
export class DataFieldGroupListDataService {
    constructor(private injector: Injector) {}

    getInstance(isLocalSort?: boolean) {
        return new DataFieldGroupListData(this.injector, isLocalSort);
    }
}

export class DataFieldGroupListData extends ListData<DataFieldGroupModel> {
    constructor(injector: Injector, isLocalSort?: boolean) {
        super(injector, isLocalSort);

        this.ShowCheckBox = false;
        this.ShowDelete = false;
        this.ObjectType = ObjectTypes.DataFieldGroup;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.name'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: FiStateNames.OtherSettings.DataField,
                    SrefParams: (data) => ({ ObjectType: data.ObjectType }),
                    secondaryValue: (data) => {
                        return (
                            injector.get(FiFormatDateService).formatDate(data.ChangedOn, 'date') +
                            ' ' +
                            data.ChangedByUserName
                        );
                    },
                }),
            ),
        );

        this.addDescriptionHeader();

        this.addChangedOnHeader();
    }

    initializeData(contentLanguagesService: ContentLanguagesService, data: DataFieldGroupModel[]) {
        this.appendData(data.map((item) => new DataFieldGroupModel(contentLanguagesService, item)));
    }
}
